<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-clipboard-account
            </v-icon>
            <span class="title">Data Pengiriman Pesan</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            @change="changeTab">
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Pesan
              <v-icon large>mdi-email-multiple-outline</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>mdi-email-plus-outline</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.tipe"
                          :items="listtipe"
                          label="Jenis pesan"
                          @change="getList">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.status"
                          :items="listyesno"
                          label="Status pengiriman"
                          @change="getList">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editJeniskerja(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formadddata"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-model="addnew.pes_tujuan"
                                :items="listcontact"
                                :rules="[rules.required]"
                                label="Tujuan"
                                name="tujuan"
                                multiple>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addnew.pes_judul"
                                :rules="[rules.required]"
                                label="Judul"
                                name="judul"
                                required>
                              </v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addnew.pes_isi"
                                auto-grow
                                label="Isi pesan"
                                rows="1">
                              </v-textarea>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                class="mt-2"
                                v-model="addnew.pes_tipe"
                                :items="listtipe"
                                :rules="[rules.required]"
                                label="Tipe pesan"
                                name="tipepesan">
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div><label>Dikirim pada</label></div>
                              <date-picker
                                class="width100"
                                v-model="addnew.pes_waktu"
                                type="datetime"
                                placeholder="waktu kirim"
                                format="YYYY-MM-DD HH:mm:ss"
                                value-type="format"
                                default-value>
                              </date-picker>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.jeniskerja"
      max-width="600px"
      v-if="dmodaldata.jeniskerja">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <alertsp :alertdata="alertupdate"></alertsp>
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejeniskerja"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jeniskerja.pes_judul"
                        :rules="[rules.required]"
                        label="Judul"
                        name="judul"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.jeniskerja.pes_isi"
                        auto-grow
                        label="Isi pesan"
                        rows="1">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statuskerja"
                        v-model="dmodaldata.jeniskerja.status_kerja"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('jeniskerja')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../../components/Alert.vue';
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'PesanAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      getreqdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    listyesno: ['wait', 'done', 'all'],
    listtipe: ['email', 'wa', 'all'],
    listcontact: ['628987421472', 'all'],
    filter: {
      search: '',
      status: 'all',
      tipe: 'all',
      location: '',
    },
    filterreq: {
      search: '',
      status: 'review',
      location: '',
    },
    headers: [
      { text: 'Judul', value: 'pes_judul' },
      { text: 'Tipe', value: 'pes_tipe' },
      { text: 'Tujuan', value: 'pes_tujuan' },
      { text: 'Waktu', value: 'pes_waktu' },
      { text: 'Status', value: 'pes_status' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    datareq: [],
    addnew: {
      pes_judul: '',
      pes_tipe: '',
      pes_tujuan: '',
      pes_waktu: new Date(Date.now() + (3600 * 1000 * 8)).toISOString().substr(0, 10) + ' 00:00:00',
      pes_isi: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
    },
    tabdata: 'tab-list',
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.changeTab();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    changeTab() {
      if (this.tabdata === 'tab-list') {
        this.getList();
      } else if (this.tabdata === 'tab-addnew') {
        // this.getReqcompany();
      }
    },
    getList() {
      this.loading.getdata = true;
      this.datalist = [];
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/pesan/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    getReqcompany() {
      this.loading.getreqdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/company/admin',
            {
              params: this.filterreq,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datareq = resdata.data;
              }
            }
            this.loading.getreqdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getreqdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formadddata.validate()) {
        if (this.tokenscr) {
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addnew,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formadddata.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getList();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.pes_judul + '" berhasil diubah!';
                  this.getList();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    DatePicker,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
